<template>
    <div id="Breadcrumb">
        <div class="haderShow">

<!--            <a-breadcrumb-item  v-for="(item, index) in routerConfig" :key="index">-->
<!--                <a :href="item.path">{{item.name}}</a>-->
<!--            </a-breadcrumb-item>-->

            <div v-for="(item, index) in routerConfig" :key="index" @click="gotoNextPage(item.fullPath)">
                <span class="routerLink" :to="item.path">{{item.name}}</span>
                <span v-if="index < routerConfig.length-1">/</span>
            </div>
        </div>
        <!--        <a-breadcrumb>-->
        <!--            <a-breadcrumb-item><a :class="{linkNormal: 1, linkActive: 0}" @click="gotoNextPage('/')">Home</a>-->
        <!--            </a-breadcrumb-item>-->
        <!--            <a-breadcrumb-item><a @click="gotoNextPage('main')">Main</a></a-breadcrumb-item>-->
        <!--        </a-breadcrumb>-->
    </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      activeKey: ''
    }
  },
  destroyed () {
  },
  created () {
  },
  props: ['routerConfig'],
  methods: {
    gotoNextPage (newPathKey) {
      if (this.$route.fullPath === newPathKey) {
        return
      }
      if (newPathKey === '/') {
        this.$router.push('/')
        return
      }
      this.$router.push({ path: newPathKey })
    }
  },
}
</script>

<style lang="less" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    .linkActive {
        color: #42b983;
    }

    .linkNormal {
        color: #2c3e50;
    }

    #Breadcrumb {
        background-color: rgba(66, 139, 202, 1);
        width: 100%;
        height: 40px;

        .haderShow {
            margin-left: 20px;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
            line-height: 40px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            flex-wrap: nowrap;
            text-align: left;
            a{
                color:  #ffffff;
            }
            div {
                span{
                    margin-left: 10px;
                }
            }
        }
        .routerLink:hover{
            cursor:pointer;
        }
    }
</style>
